import { setPageStateById } from '../PageContext';

export const setConstructing = (setState: setPageStateById) => (constructing: boolean) => {
  setState('SET_PAGE_CONSTRUCTING', (s) => ({
    ...s,
    constructing,
  }));
};
